import React from 'react';
import style from './StatsPanel.css';
const openCloseStats = (visible, available) => {
    if (available > visible)
        return style.toggleCount;
    return `${style.toggleCount} ${style.closeStats}`;
};
const StatBox = ({ stat, localizedLabel }) => {
    const label = localizedLabel || stat.label;
    return (React.createElement("div", { className: `${style.stat} ${style[stat.id]}` },
        React.createElement("div", { className: style.label }, label),
        React.createElement("div", { className: style.value, "data-measure": stat.measure }, stat.value)));
};
const Expander = ({ maxCount, visCount, minCount, toggleVisible }) => {
    if (maxCount <= minCount)
        return null;
    return (React.createElement("div", { className: openCloseStats(visCount, maxCount), onClick: () => {
            toggleVisible(visCount < maxCount ? maxCount : minCount);
        } },
        "Stats",
        React.createElement("div", null,
            React.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: '16px', height: '12px' },
                React.createElement("g", { fill: 'none' },
                    React.createElement("polyline", { stroke: 'rgb(240,240,240)', strokeWidth: '2', points: '0 2 8 10 16 2' }))))));
};
const StatsPanel = ({ statsArr = [], numberVisible = 0, numberAvailable = 0, defaultStatsVisible = 0, statLabelsLocalized = {}, toggleVisible, showModal, }) => {
    if (showModal)
        return null;
    return (React.createElement("div", { className: style.statsPanel },
        React.createElement("div", { className: style.statsList }, statsArr.slice(0, numberVisible).map(stat => (React.createElement(StatBox, { key: stat.label, stat: stat, localizedLabel: statLabelsLocalized[stat.id] })))),
        React.createElement(Expander, { minCount: defaultStatsVisible, maxCount: numberAvailable, visCount: numberVisible, toggleVisible: toggleVisible })));
};
export default StatsPanel;
